export default "__VITE_ASSET__CQhN$XkR__"